import {ReviewFormController} from "@/scripts/components/review-form/reviewFormController";
import {ReviewFormProps} from "@/scripts/components/review-form/reviewForm.types";
import "./reviewForm.scss";

export function defineReviewFormElement() {

  const TAG_NAME = "ab-review-form";

  if (customElements.get(TAG_NAME)) return;

  class AbReviewFormElement extends HTMLElement {

    get productId() { return this.getAttribute("product-id") ?? ""; }
    set productId(v: string) { this.setAttribute("product-id", v); }

    get productIdWp() { return this.getAttribute("wp-product-id") ?? ""; }
    set productIdWp(v: string) { this.setAttribute("wp-product-id", v); }

    #ctrl?: ReviewFormController;

    static get observedAttributes() {
      return ["product-id", "wp-product-id"];
    }

    connectedCallback() {
      if (this.firstChild) return; // already mounted
      this.classList.add(TAG_NAME);
      const productId = this.productId || undefined;
      const productIdWp = this.productIdWp || undefined;
      const props = { productId, productIdWp };
      this.#ctrl = new ReviewFormController(this, props);
      this.#ctrl.mount();
    }

    disconnectedCallback() {
      this.#ctrl?.unmount();
      this.#ctrl = undefined;
    }

    attributeChangedCallback(
      name: string,
      _oldVal: string|null,
      _newVal: string|null
    ){
      console.log("attributeChangedCallback", name, _oldVal, _newVal);
      if (!this.isConnected || !this.#ctrl) return;
      if (name === "product-id") {
        this.#ctrl.updateProps({ productId: this.productId });
      }
    }


  }
    customElements.define(TAG_NAME, AbReviewFormElement);
}